import { Routes } from '@angular/router';
import { privilegeGuard } from '../../../common/guards/privilege-guard';
import { QR_MENU_MODULE } from '../../../common/constants/modules';
// prettier-ignore
const SECTIONS = [
  'resto-orders',
  'section',
  'resto-table',
  'ingredient',
  'semi-product',
  'food',
  'production',
  'modificators',
  'qr-menu'
];
const dynamicRoutes: Routes = SECTIONS.map((path) => ({
  path: path,
  redirectTo: `restaurant/${path}`,
  pathMatch: 'full',
}));
export const restaurantRoutes: Routes = [
  ...dynamicRoutes,
  {
    path: 'restaurant/production',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-production/resto-production').then(
        (x) => x.RestoProduction,
      ),
    data: { privileges: ['production'], moduleName: 'production' },
  },
  {
    path: 'restaurant/production/add-edit/:operationId',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-production/res-production-add-edit/res-production-add-edit').then(
        (x) => x.ResProductionAddEdit,
      ),
    data: { privileges: ['production'], moduleName: 'production' },
  },
  {
    path: 'restaurant/production/add-edit/:operationId/:isCopy',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-production/res-production-add-edit/res-production-add-edit').then(
        (x) => x.ResProductionAddEdit,
      ),
    data: { privileges: ['production'], moduleName: 'production' },
  },
  {
    path: 'restaurant/production/add-edit',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-production/res-production-add-edit/res-production-add-edit').then(
        (x) => x.ResProductionAddEdit,
      ),
    data: { privileges: ['production'], moduleName: 'production' },
  },
  {
    path: 'restaurant/resto-orders',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-order-history/resto-order-history').then(
        (x) => x.RestoOrderHistory,
      ),
    data: {
      privileges: ['resto_order_history_view'],
      moduleName: 'resto-orders',
    },
  },
  {
    path: 'restaurant/section',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./res-section/res-section').then((x) => x.ResSection),
    data: { privileges: ['resto_hall_table_view'], moduleName: 'section' },
  },
  {
    path: 'restaurant/resto-table',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-table/resto-table').then((x) => x.RestoTable),
    data: { privileges: ['resto_hall_table_view'], moduleName: 'resto-table' },
  },
  {
    path: 'restaurant/ingredient',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-ingredient/resto-ingredient').then(
        (x) => x.RestoIngredient,
      ),
    data: { privileges: ['resto_menu_view'], moduleName: 'ingredient' },
  },
  {
    path: 'restaurant/semi-product',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-semi-product/resto-semi-product').then(
        (x) => x.RestoSemiProduct,
      ),
    data: { privileges: ['resto_menu_view'], moduleName: 'semi-product' },
  },
  {
    path: 'restaurant/food',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-food/resto-food').then((x) => x.RestoFood),
    data: { privileges: ['resto_menu_view'], moduleName: 'food' },
  },
  {
    path: 'restaurant/modificators',
    canActivate: [privilegeGuard],
    loadComponent: () =>
      import('./resto-modificators/resto-modificators').then(
        (x) => x.RestoModificators,
      ),
    data: { privileges: ['resto_menu_view'], moduleName: 'modificators' },
  },
  {
    // саб-модуль qr-menu модуля «Меню»: только проверка модуля, без привилегий
    // (решение владельца 2026-10-07). Намеренно БЕЗ ключа privileges: гард
    // пропускает любой ROLE_USER* при наличии модуля (privilege-guard.ts:24).
    // privileges: [''] — не «без гейта»: массив длины 1 → hasOnePrivilege('')
    // → 401 для подролей ROLE_USER_X (как у remains в user-main.routes.ts).
    // Без canActivate — гарды уже идут из canActivateChild оболочки user-main
    path: 'restaurant/qr-menu',
    loadComponent: () =>
      import('./resto-qr-menu/resto-qr-menu').then((x) => x.RestoQrMenu),
    data: { moduleName: QR_MENU_MODULE },
  },
];
